<div class="table-title d-flex flex-column flex-md-row align-items-center ">
    <div class="ml-lg-3">
        <span
            *ngIf="sectionTitleConfig.required"
            style="color: #ff0101; margin-left: 12px"
            >*</span
        >
        <img
            [src]="sectionTitleConfig.imgPath"
            class="magnifying-glass-title__icon"
            [alt]="sectionTitleConfig.altText"
        />
    </div>
    <h3 class="d-inline-block align-self-center ml-lg-4 section-title">
        {{ sectionTitleConfig.sectionTitle }}
    </h3>
</div>
